import {useState, useEffect} from "react";
import { GlobalVars } from "../../../state/global/globalVars";
import UilAngleDown from "@iconscout/react-unicons/icons/uil-angle-down";

export default function Dropdown(props) {
    const {
        classList,
        className,
        disabled,
        error,
        label,
		vertSize,
        lgHideLabel,
        name,
        options,
        onChange,
        placeholder,
        readOnly,
        value,
        ...rest
    } = props;

    const [isOpen, setIsOpen] = useState(false);
    const [icon, setIcon] = useState();
    const [display, setDisplay] = useState();

	const handleBlur = (e) => {
		isOpen && setIsOpen(false);
	};

    // disabled hides the control; readOnly keeps the value visible but inert
    const handleClick = (e) => {
		if (!disabled && !readOnly) {
			setIsOpen(!isOpen);
        }
    };
	
    const handleChange = (event, i, d) => {
		event.target.name = name;
        event.target.value = event.target.id;
        onChange(event);
        setIcon(i);
        setDisplay(d);
        setIsOpen(false);
    };

	useEffect(() => {
		if (value) {
			let selected = options.find((e) => e.value == value);
			setDisplay(selected?.selectDisplay ? selected.selectDisplay : selected?.display);
		}
	}, [options]);

	useEffect(() => {
		if (value) {
			let selected = options.find((e) => e.value == value);
			setIcon(selected?.icon);
			setDisplay(selected?.selectDisplay ? selected.selectDisplay : selected?.display);
		}
	}, [value]);

    return (
        <div className={`${label ? "space-y-[3px]" : "" }  ${className}`} {...rest} >
            {error && (
                <div className="relative text-status-error">
                    <span className={`absolute right-0 ${label ? "top-2" : "-top-4"} text-xs italic`}>{error}</span>
                </div>
            )}

            {label && 
                <div className={`text-sm font-semibold ${error ? "text-status-error" : ""} ${lgHideLabel ? "lg:hidden pb-[1px] lg:pb-0" : "pb-[1px]"}`}>{label}</div>
            }
            
            <div tabIndex="-1"
                className={`${readOnly ? "hover:cursor-not-allowed opacity-60" : "hover:cursor-pointer"} relative bg-light-11 ${disabled && "hidden"} ${error ? "border-status-error" : value ? "border-light-2" : "border-light-4"} ${isOpen ? "border rounded-t" : "border rounded"}`}
                onClick={handleClick}
                onBlur={handleBlur}
            >
                <div className="text-sm flex items-center justify-between px-2 py-2 whitespace-nowrap">
                    {value && value > -1 ? <div className="flex gap-2 overflow-hidden"><div>{icon}</div>{display}</div> : <p className="text-gray-500 text-clip overflow-hidden">{placeholder ? placeholder : "Select an Option"}</p>}
                    <UilAngleDown size={GlobalVars.iconSize.md} className={`-m-[2.5px] ${isOpen ? "rotate-180 text-light-3" : "text-light-2"}`}/>
                </div>
                {isOpen && (
                    <ul className={`dropdown-menu absolute shadow-lg pb-0 bg-light-11 z-20 border ${value ? "border-light-2" : "border-light-4"} border-t-0 ${vertSize ? `${vertSize} overflow-y-auto rounded-bl` : "rounded-b"}`} style={{width: "calc(100% + 2px)", left: "-1px"}}>
                        {options.map((option) => (
                            <li key={option.value} className="border-t border-light-8">
                                <div name={name}
                                    onClick={(event) => handleChange(event, option.icon, option.selectDisplay ? option.selectDisplay : option.display)}
                                    className={`transition ease-in-out duration-150 flex gap-3 px-3 py-1 w-full text-sm border-transparent border-l-4 hover:bg-light-3/30 hover:border-light-3 ${classList}`}
                                    id={option.value}
                                >
                                    {option.icon &&
                                        <div>{option.icon}</div>
                                    }
                                    {option.display}
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}

/*

Sample Props

label="Dropdown"
classList="tailwind classes"  //css classes of each dropdown list item
lgHideLabel={true}
readOnly={true}  //shows the value greyed out and won't open; unlike disabled, which hides the control
vertSize="max-h-52 sm:max-h-60"
options={[
    { value: "1", display: "sometext", icon: <UilSave />},
    { value: "2", display: "sometext", selectDisplay: "text" },
    { value: "3", display: "sometext" },
    { value: "4", display: "sometext" },
    { value: "5", display: "sometext" },
    { value: "6", display: "sometext" },
    { value: "7", display: "sometext" },
    { value: "8", display: "sometext" },
    { value: "9", display: "sometext" },
    { value: "10", display: "sometext" },
]}
value={value}
onChange={setValue}

 */